<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Little Orange Nightbook</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About The Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#acknowledgement">Acknowledgements</a></li>
<li id="toc-li-4"><a href="#/text/ch004#introduction">Introduction</a></li>
<li id="toc-li-6"><a href="#/text/ch005#on-a-string-and-a-prayer">A: On A String and A Prayer</a></li>
<li id="toc-li-9"><a href="#/text/ch006#a-step-back-in-time">B: A Step, Back in Time</a></li>
<li id="toc-li-12"><a href="#/text/ch007#and-my-part-in-the-defeat-of-nazi-germany">C: And My Part
                    in The Defeat of Nazi Germany</a></li>
<li id="toc-li-15"><span href="#/text/ch008#a-peasant-surprise" title="Link target outside of Sample">D: A Peasant Surprise</span></li>
<li id="toc-li-19"><span href="#/text/ch009#and-the-band-played-on" title="Link target outside of Sample">E: …And the Band Played On</span></li>
<li id="toc-li-22"><span href="#/text/ch010#la-vie-de-bohème" title="Link target outside of Sample">F: La Vie de Bohème!</span></li>
<li id="toc-li-25"><span href="#/text/ch011#s-no-joke" title="Link target outside of Sample">G: ’S No Joke!</span></li>
<li id="toc-li-28"><span href="#/text/ch012#on-the-far-horizon" title="Link target outside of Sample">H: On the Far Horizon</span></li>
<li id="toc-li-32"><span href="#/text/ch013#making-the-most-of-nothing" title="Link target outside of Sample">I: Making the Most of
                    Nothing</span></li>
<li id="toc-li-35"><span href="#/text/ch014#waving-not-drowning" title="Link target outside of Sample">J: Waving, Not Drowning</span></li>
<li id="toc-li-39"><span href="#/text/ch015#separate-honeymoons" title="Link target outside of Sample">K: Separate Honeymoons</span></li>
<li id="toc-li-43"><span href="#/text/ch016#same-options-maybe-different-outcomes" title="Link target outside of Sample">L: Same Options,
                    Maybe Different Outcomes</span></li>
<li id="toc-li-47"><span href="#/text/ch017#unloved-but-not-uneaten" title="Link target outside of Sample">M: Unloved, But Not Uneaten</span></li>
<li id="toc-li-51"><span href="#/text/ch018#castles-in-the-air" title="Link target outside of Sample">N: Castles in the Air</span></li>
<li id="toc-li-55"><span href="#/text/ch019#world-class-ruts-and-an-uninvited-guest-for-lunch" title="Link target outside of Sample">O: World-Class
                    Ruts and An Uninvited Guest for Lunch</span></li>
<li id="toc-li-59"><span href="#/text/ch020#i-cod-you-not" title="Link target outside of Sample">P: I Cod You Not!</span></li>
<li id="toc-li-62"><span href="#/text/ch021#a-scheduled-trip-becomes-two" title="Link target outside of Sample">Q: A Scheduled Trip Becomes
                    Two</span></li>
<li id="toc-li-65"><span href="#/text/ch022#blackheads-and-black-balsam" title="Link target outside of Sample">R: Blackheads and Black
                    Balsam</span></li>
<li id="toc-li-69"><span href="#/text/ch023#flags-from-the-past-foreshadow-problems-for-the-future" title="Link target outside of Sample">S: Flags
                    from the Past Foreshadow Problems for the Future</span></li>
<li id="toc-li-72"><span href="#/text/ch024#alone-on-the-mongolian-steppe-darkness-engulfed-me" title="Link target outside of Sample">T: Alone on
                    The Mongolian Steppe Darkness Engulfed Me</span></li>
<li id="toc-li-76"><span href="#/text/ch025#standing-up-to-extremists" title="Link target outside of Sample">U: Standing Up to
                    Extremists</span></li>
<li id="toc-li-79"><span href="#/text/ch026#seeing-the-back-of-the-king" title="Link target outside of Sample">V: Seeing the Back of the
                    King</span></li>
<li id="toc-li-83"><span href="#/text/ch027#twinning-with-a-vengeance-or-rather-without" title="Link target outside of Sample">W: Twinning
                    with a Vengeance or Rather, Without</span></li>
<li id="toc-li-86"><span href="#/text/ch028#be-sure-ye-are-covered" title="Link target outside of Sample">Y: Be Sure Ye Are Covered</span></li>
<li id="toc-li-89"><span href="#/text/ch029#lost-on-a-train-in-western-bosnia" title="Link target outside of Sample">Z: Lost on A Train in
                    Western Bosnia</span></li>
<li id="toc-li-92"><span href="#/text/ch030#epilogue" title="Link target outside of Sample">Epilogue</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?7f214bd2